import { render, staticRenderFns } from "./SalesmanForm.vue?vue&type=template&id=f4b7943a"
import script from "./SalesmanForm.vue?vue&type=script&lang=js"
export * from "./SalesmanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports